import { render, staticRenderFns } from "./AddAccountant.vue?vue&type=template&id=320aa6b1"
import script from "./AddAccountant.vue?vue&type=script&lang=js"
export * from "./AddAccountant.vue?vue&type=script&lang=js"
import style0 from "./AddAccountant.vue?vue&type=style&index=0&id=320aa6b1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports